import {mapNullToUndefined} from '../utils/zod';
import {CreatePartnerSiteRequest} from './../api/generated/index.defs';
import {z} from 'zod';

export const partnerSiteSchema = z.object({
  sendEvaluationToActiveUser: mapNullToUndefined(z.boolean().optional()),
  inactive: mapNullToUndefined(z.boolean().optional()),
  sortOrder: mapNullToUndefined(z.number().optional()),
  timeDifference: mapNullToUndefined(z.string().optional()),
  arfNumber: z.string(),
  name: z.string(),
  signatureUrl: z.string(),
  signatoryName: z.string(),
  signatoryTitle: z.string(),
  logoUrl: z.string(),
  arfSealUrl: z.string(),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  country: z.string(),
  zipCode: z.string(),
}) satisfies z.ZodSchema<CreatePartnerSiteRequest>;

export type PartnerSiteSchema = z.infer<typeof partnerSiteSchema>;
